import { Link } from "react-router-dom";
import { ArrowUpRight, Droplets, Thermometer, Hammer, Sun, Layers, PaintRoller, Waves, Shield, Sparkles } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  { icon: Hammer, code: "S.01", t: "Ristrutturazioni Chiavi in Mano", d: "Gestione completa del cantiere residenziale con un unico interlocutore, dalla progettazione alle finiture.", to: "/ristrutturazioni-chiavi-in-mano" },
  { icon: Droplets, code: "S.02", t: "Impermeabilizzazione in Poliurea", d: "Membrana poliurea a spruzzo per coperture, terrazzi, vasche e fondazioni. Impermeabile in pochi secondi.", to: "/impermeabilizzazione-poliurea" },
  { icon: Thermometer, code: "S.03", t: "Coibentazione in Poliuretano", d: "Isolamento termico a spruzzo per pareti, sottotetti e coperture. Elimina ponti termici e dispersioni.", to: "/coibentazione-poliuretano" },
  { icon: Sun, code: "S.04", t: "Efficientamento Energetico", d: "Impianti fotovoltaici ad alto rendimento per produrre energia pulita e abbattere i costi in bolletta.", to: "/efficientamento-energetico" },
  { icon: Layers, code: "S.05", t: "Pareti Ventilate", d: "Sistemi di facciata ventilata che isolano, proteggono l'edificio e ne trasformano l'estetica.", to: "/pareti-ventilate" },
  { icon: Waves, code: "S.06", t: "Rivestimenti Piscine", d: "Innovativo rivestimento polimerico continuo, impermeabile ed elegante per piscine nuove ed esistenti.", to: "/rivestimenti-piscine" },
  { icon: Shield, code: "S.07", t: "Rivestimenti Protettivi Anticorrosivi", d: "Spruzzatura a fiamma di polveri termoplastiche per protezione conservativa e anticorrosione.", to: "/rivestimenti-protettivi" },
  { icon: Sparkles, code: "S.08", t: "Restauro Conservativo", d: "Microaeroabrasione selettiva, pulitura e trattamento protettivo delle superfici storiche.", to: "/restauro-conservativo" },
  { icon: PaintRoller, code: "S.09", t: "Finiture e Rivestimenti", d: "Pavimentazioni, intonaci, tinteggiature e finiture di pregio per interni ed esterni, incluso il risanamento dell'umidità di risalita.", to: "/finiture-e-rivestimenti" },
];

export default function Servizi() {
  return (
    <div data-testid="servizi-page">
      <PageHeader
        index="/ 02"
        title="Servizi"
        lines={["Cosa", "facciamo."]}
        subtitle="Un ventaglio completo di servizi tecnici per l'edilizia residenziale, con due specializzazioni verticali che fanno la differenza: poliurea e poliuretano."
        logo
      />

      <section className="pb-24 md:pb-32 bg-background">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
            {SERVICES.map((s, i) => (
              <Reveal key={s.code} delay={(i % 3) * 0.08}>
                <Link to={s.to} data-testid={`servizi-item-${s.code}`} className="group bg-card p-8 h-full flex flex-col hover:bg-secondary/50 transition-colors">
                  <div className="flex items-center justify-between mb-8">
                    <s.icon className="w-8 h-8 text-primary" />
                    <span className="font-mono text-xs text-muted-foreground">{s.code}</span>
                  </div>
                  <h3 className="font-head font-bold text-2xl tracking-tight mb-3">{s.t}</h3>
                  <p className="text-muted-foreground leading-relaxed flex-1">{s.d}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest group-hover:text-primary group-hover:gap-3 transition-all">
                    Dettagli <ArrowUpRight className="w-4 h-4" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
